import { motion } from 'framer-motion';
import React, { FC } from 'react';

import VideoComponent from '../shared/VideoComponent';

interface MultiSelectPopupInterface {
  onClick?: () => void;
}

const MultiSelectPopup: FC<MultiSelectPopupInterface> = ({ onClick }): JSX.Element => (
  <motion.div
    initial={{
      opacity: 0,
      scale: 0
    }}
    animate={{
      opacity: 1,
      scale: 1
    }}
    exit={{
      opacity: 0,
      scale: 0
    }}
    transition={{
      duration: 0.5
    }}
    className="multi-select-popup-container"
  >
    <div className="multi-select-popup">
      <div className="multi-select-popup-close">
        <img
          onClick={onClick}
          src={`${process.env.PUBLIC_URL}/assets/images/close-icon.png`}
          alt=""
        />
      </div>
      <div className="multi-select-title">Just To Remind You</div>
      <div className="multi-select-sub-title desc">you can select multi regions</div>
      <div className="multi-select-list">
        <VideoComponent
          src={`${process.env.PUBLIC_URL}/assets/videos/regions-popup.webm`}
          fallbackImage={`${process.env.PUBLIC_URL}/assets/images/pages/regions-popup.png`}
        />
      </div>
      <div
        onClick={onClick}
        className="multi-select-sub-title got-it"
      >
        Ok, Got it
      </div>
    </div>
  </motion.div>
);

export default MultiSelectPopup;
